<template>
  <v-app id="onHuis">
    <defNavBar v-if="!crash&&!loading" title="Ares - Accommodation" :actions="huis.action_items" :accolist="true" :home="true"
      :attms="huis.attm_aant" :notts="huis.nott_aant" @actionClick="actionClick" />
    <v-main>
      <div v-if="!loading&&!crash">
        <v-container fluid>
          <v-row cols="12">
            <v-col cols="4" class="px-1"> <!-- Links -->
              <v-container>
                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-form ref="huisCard1" v-model="huisCard1Valid">
                        <div :class="{'error-indent': huis.hserNumberOfErrors!==0}">
                        <v-card-title><span>Accommodation {{ huis.huis_code }}</span>
                          <v-spacer></v-spacer>
                          <v-avatar color="red" size=30 @click="getHser('Error')" v-show="huis.hserNumberOfErrors!==0">{{
                            huis.hserNumberOfErrors }}</v-avatar>
                          <v-avatar color="orange" size=30 @click="getHser('Warning')" v-show="huis.hserNumberOfWarnings!==0">{{
                            huis.hserNumberOfWarnings }}</v-avatar>
                          <hser ref="hser"></hser>
                        </v-card-title>
                        <v-card-subtitle class="pb-0">{{ huis.cttptaal_oms }}</v-card-subtitle>
                        <v-card-text v-if="huis.product_partner.ikpt_code !== ''" class="ma-0 pb-0 font-weight-bold">
                            Product partner: {{ huis.product_partner.ikpt_naam }}
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                                </template>
                                <span v-html="huis.product_partner.ikpt_info"></span>
                            </v-tooltip>
                        </v-card-text>
                        </div>
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="6" class="px-1">
                              <v-text-field v-model="huis.huis_naam" :rules="huis_naamRules"
                                label="Name"></v-text-field>
                            </v-col>
                            <v-col cols="4" class="px-1">
                              <v-select v-model="huis.hstp_nr" :items="hstp_nrKeuzes" item-value="hstp_nr"
                                item-text="hstptaal_oms" label="Type"></v-select>
                            </v-col>
                            <v-col cols="1" class="px-1">
                              <btn_audit table="huis" :encrid="huis.huis_encrid" :size=30
                                tooltip="audit of accommodation" />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>

                            <v-col cols="3" class="px-1">
                              <v-text-field v-model="huis.huis_aantpers_max" label="Max Pers" type="number"
                                prepend-icon="mdi-account" :rules="huis_aantpers_maxRules" dense
                                :readonly="huis.huis_aantpers_max_readonly"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-model="huis.huis_aant_baby_os" label="Max extra babies" type="number"
                                :rules="huis_aant_baby_osRules" dense
                                :readonly="huis.huis_aant_baby_os_readonly"></v-text-field>
                            </v-col>
                            <v-col cols="1" class="px-1">
                              <v-text-field v-model="huis.stat_code" label="Status" dense readonly></v-text-field>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="huis.huis_statd_dat" label="D-Date" dense readonly></v-text-field>
                            </v-col>

                            <v-col cols="2" class="px-1">
                              <v-menu v-model="huis.huis_statw_datMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="huis_statw_dat" label="W-Date" v-on="on" dense></v-text-field>
                                </template>
                                <v-date-picker v-model="huis.huis_statw_dat2" :first-day-of-week="1"
                                  :min="minDate"
                                  @input="huis_statw_dat = $moment(huis.huis_statw_dat2).format('DD-MM-YYYY'); huis.huis_statw_datMenu = false"></v-date-picker>
                              </v-menu>
                            </v-col>

                          </v-row>
                          <v-row no-gutters v-if="showRdoz">
                            <v-col cols="9" class="px-1">
                              <v-autocomplete v-model="rdoz_selected" required
                                :items="huis.rdoz.keuzes" item-value="value" item-text="text"
                                label="Required: Reason for status W" dense multiple clearable>
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="1" class="px-1">
                            </v-col>
                            <v-col cols="11" class="px-1">
                              <v-textarea v-model="huis.rdoz.rdoz_note" label="Optional: Explanation for status W (will be saved to memo/note)" dense></v-textarea>
                            </v-col>
                            <v-col cols="1" class="px-1">
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="6" class="px-1">
                              <v-select v-model="rental_expert" :items="gebr_codeKeuzes" item-value="gebr_code"
                                item-text="gebr_naam" label="Rental Expert" dense></v-select>
                            </v-col>

                            <v-col cols="6" class="px-1">
                              <v-select v-model="huis.gebr_code_binnendienst" :items="gebr_codeKeuzes"
                                item-value="gebr_code" item-text="gebr_naam" label="Contact" dense></v-select>
                            </v-col>

                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="6" class="px-2">
                              <v-rating v-model="huis.huis_ster" dense></v-rating>
                            </v-col>
                            <v-col cols="6" class="px-1">
                              <v-chip :color="huis.availability_period" dense>Website availability </v-chip>
                            </v-col>

                            <v-col cols="4" class="px-1">
                              <v-select v-if="hgrp_codeKeuzes.length > 0" v-model="huis.hgrp_code"
                                :items="hgrp_codeKeuzes" item-value="hgrp_code" item-text="hgrp_oms" label="Group"
                                dense></v-select>
                            </v-col>

                            <v-col cols="4" class="px-1 mt-2">
                              <v-switch v-show="moreThan1HsplRecord" v-model="huis.huis_combi"
                                :label="`Combi units: ${huis.huis_combi === true ? 'Yes' : 'No'}`"></v-switch>
                            </v-col>
                            <v-col v-if="huis.OwnerIsPark === true || huis.IsCollection===true" cols="8" class="px-1 mt-2"
                              style="display:flex; flex-direction: row;">
                              <v-text-field flat :readonly=true :label="huis.IsCollection===true ? 'Collection' : 'Park name'"  v-model="huis.Groupname" class="pr-4" />
                              <v-text-field flat :readonly=true label="Connection name" v-model="huis.ConnectionName"
                                class="pr-4" />
                            </v-col>

                          </v-row>

                          <v-row no-gutters class="mt-2">
                            <v-col cols="12" class="px-1">
                                <actie ref=actie1 :key="actionKey" :huis_encrid="huis.huis_encrid" :huis_actie_datum="huis.huis_actie_datum_2" :huis_actie_opm="huis.huis_actie_opm" :huis_code="huis.huis_code" @updateData="updateAction"/>
                            </v-col>
                          </v-row>

                          <v-row no-gutters class="mt-2">
                            <v-col cols="4" class="px-1">
                              <v-text-field v-model="huis.huis_gps" readonly @click="showMap(huis.huis_encrid)"
                                label="Latitude / Longitude" dense></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="12" class="px-1">
                              <v-text-field v-model="huis.huis_adres" :rules="huis_adresRules" label="Manual Address"
                                dense></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-model="huis.huis_postcode" :rules="huis_postcodeRules"
                                label="Postcal code" dense></v-text-field>
                            </v-col>
                            <v-col cols="7" class="px-1">
                              <v-select v-model="huis.plts_nr" :items="plts_nrKeuzes" item-value="plts_nr"
                                item-text="plts_naam" label="City" dense></v-select>
                            </v-col>
                            <v-col cols="1">
                              <v-btn class="primary" x-small @click="addPlts(huis.huis_encrid)">Add</v-btn>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>

                            <v-col cols="4" class="px-1">
                              <v-select v-model="huis.prov_code" :readonly="huis.prov_code_readonly"
                                :items="prov_codeKeuzes" item-value="prov_code" item-text="provtaal_oms"
                                label="Province" dense></v-select>
                            </v-col>

                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="8" class="px-1">
                              <v-select v-model="huis.hsav_nr" :items="hsav_nrKeuzes" item-value="hsav_nr"
                                item-text="hsav_oms" label="Cancellation policy" dense></v-select>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="12" class="px-1">
                              <v-select v-model="huis.huis_aantnacht_max" :items="aantnacht_maxKeuzes"
                                item-value="aantnacht_max_nr" item-text="aantnacht_max_oms" label="Max nr of Nights"
                                dense></v-select>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="12" class="px-1">
                              <v-select v-model="huis.huis_lm_term" :items="lmterm_nrKeuzes" item-value="lmterm_nr"
                                item-text="lmterm_oms" label="Last minute term" dense></v-select>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="8" class="px-1">
                              <v-select v-model="huis.mrkt_nr" :items="mrkt_nrKeuzes" item-value="mrkt_nr"
                                item-text="mrkt_oms" label="Occupancy level" dense></v-select>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="3" class="px-1">
                              <v-select v-model="huis.huis_aankomst_tijd1" :items="tijdKeuzes" menu-props="auto"
                                item-value="tijd_code" item-text="tijd_oms" label="Arrival from"></v-select>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-select v-model="huis.huis_aankomst_tijd2" :items="tijdKeuzes" menu-props="auto"
                                item-value="tijd_code" item-text="tijd_oms" label="Arrival Until"></v-select>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-select v-model="huis.huis_vertrek_tijd1" :items="tijdKeuzes" menu-props="auto"
                                item-value="tijd_code" item-text="tijd_oms" label="Departure from"></v-select>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-select v-model="huis.huis_vertrek_tijd2" :items="tijdKeuzes" menu-props="auto"
                                item-value="tijd_code" item-text="tijd_oms" label="Departure Until"></v-select>
                            </v-col>
                          </v-row>

                          <v-card flat>
                            <v-container class="mx-0 px-0">
                              <v-row no-gutters class="mt-4">
                                <v-col cols="6" class="px-1">
                                  <v-text-field v-model="huis.huis_bedr_oud" label="Previous company"
                                    hint="Fill in 'None' if there is no previous company" dense></v-text-field>
                                </v-col>
                                <v-col cols="6" class="px-1">
                                  <v-text-field v-model="huis.huis_code_oud" label="Previous ID"
                                    hint="Fill in 'None'  if there is no previous ID" dense></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row no-gutters dense>
                                <v-col cols="12" class="px-1">
                                  <v-text-field v-model="huis.huis_naam_org" label="Previous Name" dense></v-text-field>
                                </v-col>
                                <v-col cols="12" class="px-1">
                                  <flexfield field="flexAirBnbUrl" :flexvalue="flexAirBnbUrl" :isDense="true"
                                    label="Previous AirBnb URL" flexfield="oldairbnburl" flextable="huis"
                                    :flexkey="huis.huis_code" @updateData="updateData2" />
                                </v-col>
                                <v-col cols="12" class="px-1">
                                  <flexfield field="flexBookingUrl" :flexvalue="flexBookingUrl" :isDense="true"
                                    label="Previous Booking.com URL" flexfield="oldbookingurl" flextable="huis"
                                    :flexkey="huis.huis_code" @updateData="updateData2" />
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>

                        </v-container>

                        <v-row no-gutters>
                          <v-col cols="1" class="px-1">
                            <v-btn class="primary ma-2" :disabled="!huisCard1Valid || (showRdoz && (rdoz_selected.length===0))" x-small @click="saveHuisCard1">Save</v-btn>
                          </v-col>
                        </v-row>
                        <updAddress ref="updAddress"></updAddress>
                        <overruleAddress ref="overruleAddress"></overruleAddress>
                        <showMap ref="showMap" @updateData="updateData"></showMap>
                        <addPlts ref="addPlts" @updateData="updateData"></addPlts>

                      </v-form>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">

                    <v-card>
                      <v-card-title>Hosts<v-spacer></v-spacer>
                        <v-btn v-if="huis.copyHsctToHoct === 'Yes'" class="primary ma-2" x-small
                          @click="copyHsctToHoct(huis.huis_encrid)">Copy to Bookings</v-btn>

                        <v-btn class="primary ma-2" x-small @click="addHsct(huis.huis_encrid)">ADD HOST</v-btn>
                        <btn_audit table="hsct" :encrid="huis.huis_encrid" :size=30
                          tooltip="audit of accommodation - host" />
                      </v-card-title>

                      <v-simple-table dense>
                        <template v-slot:default>
                          <tbody v-for="(hsctRecord, i) in huis.hsct" :key="i">
                            <tr>
                              <td colspan="5" class="onlyborder"></td>
                            </tr>
                            <tr>
                              <td class="noborder">
                                <v-icon small v-if="!hsctRecord.hsct_has_password" color="warning" class="mr-2">mdi-lock-off</v-icon>
                                <v-icon small v-else style="visibility: hidden;" class="mr-2">mdi-lock-off</v-icon>
                              </td>
                              <td class="noborder">
                                {{ hsctRecord.hsct_rol }}
                              </td>
                              <td class="noborder" @click="$router.open('/eign/onEign/' + hsctRecord.eign_encrid)"><a>
                                  {{ hsctRecord.eign_code }} </a></td>
                              <td class="noborder">{{ hsctRecord.eign_naam }}</td>
                              <td class="noborder" style="min-width: 150px;">
                                <v-btn text icon @click="updHsct2(hsctRecord.hsct_encrid)"><v-icon small>mdi-wrench</v-icon></v-btn>
                                <v-btn text icon @click="updHsct(hsctRecord.hsct_encrid)" class="ml-1"><v-icon small>mdi-bell</v-icon></v-btn>
                                <v-btn v-if="hsctRecord.rmHsct === 'Yes'" text icon @click="rmHsct(hsctRecord.hsct_encrid)" class="ml-1"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                            </tr>
                            <tr v-if="hsctRecord.hsct_ctrl_detail !== ''">
                              <td class="noborder detail" colspan="6">{{ hsctRecord.hsct_ctrl_detail }} </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <updHsct ref="updHsct" @updateData="updateData"></updHsct>
                      <updHsct2 ref="updHsct2" @updateData="updateData"></updHsct2>
                      <rmHsct ref="rmHsct" @updateData="updateData"></rmHsct>
                      <addHsct ref="addHsct" @updateData="updateData"></addHsct>
                      <copyHsctToHoct ref="copyHsctToHoct" @updateData="updateData"></copyHsctToHoct>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="px-1">
                    <qualityCheck :quality_data="this.quality_check_data" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Descriptions</v-card-title>
                      <v-card-text>
                      <div class="overflow-x-auto">
                        <table class="mx-2">
                        <tr>
                          <td class="pb-2"></td>
                          <td v-for="txtHead in huis.txtsHead" :key="txtHead.i" class="pb-2">
                          <div class="xheader">
                            <country-flag v-bind:country=txtHead />
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Title</td>
                          <td v-for="txtHbesKort in huis.txtsHbesKort" :key="txtHbesKort.i"
                          :class="txtHbesKort.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'hbes-kort', txtHbesKort.taal_code)">
                          <div class="cell">
                            {{ txtHbesKort.taal_code }}
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Description</td>
                          <td v-for="txtHbes in huis.txtsHbes" :key="txtHbes.i" :class="txtHbes.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'hbes', txtHbes.taal_code)">
                          <div class="cell">
                            {{ txtHbes.taal_code }}
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Surroundings</td>
                          <td v-for="txtOmgeving in huis.txtsOmgeving" :key="txtOmgeving.i"
                          :class="txtOmgeving.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'omgeving', txtOmgeving.taal_code)">
                          <div class="cell">
                            {{ txtOmgeving.taal_code }}
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Host Tips</td>
                          <td v-for="txtEignTips in huis.txtsEignTips" :key="txtEignTips.i"
                          :class="txtEignTips.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'eign-tips', txtEignTips.taal_code)">
                          <div class="cell">
                            {{ txtEignTips.taal_code }}
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Agent Tips</td>
                          <td v-for="txtAgentTips in huis.txtsAgentTips" :key="txtAgentTips.i"
                          :class="txtAgentTips.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'agent-tips', txtAgentTips.taal_code)">
                          <div class="cell">
                            {{ txtAgentTips.taal_code }}
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Voucher text</td>
                          <td v-for="txtVtText in huis.txtsVtText" :key="txtVtText.i"
                          :class="txtVtText.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'vt-text', txtVtText.taal_code)">
                          <div class="cell">
                            {{ txtVtText.taal_code }}
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-2">Key / Access</td>
                          <td v-for="txtKeycode in huis.txtsKeycode" :key="txtKeycode.i"
                          :class="txtKeycode.descrAchtergrond"
                          @click="updTxts(huis.huis_encrid, 'keycode', txtKeycode.taal_code)">
                          <div class="cell">
                            {{ txtKeycode.taal_code }}
                          </div>
                          </td>
                        </tr>
                        </table>
                      </div>
                      </v-card-text>
                      <updTxts ref="updTxts" @updateTextData="updateData"></updTxts>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Layout<v-spacer></v-spacer>
                          <v-btn class="primary ma-2" x-small  @click="$router.open('/huis/hsii/updHsii/' + huis.huis_encrid + '/summary')">Layout</v-btn>
                          <v-badge :content="huis.layoutMessages" offset-x="16" offset-y="16" :color="huis.layoutMessages > 0 ? 'warning' : 'success'" v-if="huis.layoutNew&&huis.layoutMessages>0">
                            <v-btn class="primary ma-2" x-small  @click="$router.open('/huis/hsii/hsiiOverview/' + huis.huis_encrid)" v-if="huis.layoutNew">Layout New</v-btn>
                          </v-badge>
                          <v-btn class="primary ma-2" x-small  @click="$router.open('/huis/hsii/hsiiOverview/' + huis.huis_encrid)" v-if="huis.layoutNew&&huis.layoutMessages===0">Layout New</v-btn>
                          <btn_audit table="hsii" :encrid="huis.huis_encrid" :size=30 tooltip="audit of accommodation - layout" />
                      </v-card-title>
                      <v-row>
                        <v-col class="mx-2">
                          Bedrooms: {{ huis.huis_aantSlaapkamer }}
                        </v-col>
                        <v-col>
                          Sleep: {{ huis.huis_aantSlaapPlaatsen }}
                        </v-col>
                        <v-col>
                          Bathrooms: {{ huis.huis_aantBadkamer }}
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Properties</v-card-title>
                      <v-row no-gutters>
                        <v-col cols="2" class="mx-2">
                          <v-text-field v-model="huis.huis_m2" label="Living area m2" dense suffix="M2"
                            type="number"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="mx-2">
                          <v-select v-model="huis.huis_opties_dvvb" :items="opties_dvvb_Keuzes"
                            item-value="opties_dvvb_nr" item-text="opties_dvvb_oms" label="Options" dense></v-select>
                        </v-col>
                        <v-col cols="2" class="mx-2">
                          <v-text-field v-model="huis.huis_klnt_beoordeling" label="Guest rating" dense type="number"
                            hint="Valu 0 .. 10"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="3" class="mx-2">
                          <v-select v-model="huis.huis_gebouwd_jaar" :items="bouw_jaarKeuzes" item-value="jaar_nr"
                            item-text="jaar_oms" menu-props="auto" label="Build year" dense></v-select>
                        </v-col>
                        <v-col cols="3" class="mx-2">
                          <v-select v-model="huis.huis_gerenoveerd_jaar" :items="bouw_jaarKeuzes" item-value="jaar_nr"
                            item-text="jaar_oms" menu-props="auto" label="Renovation year" dense></v-select>
                        </v-col>
                        <v-col cols="3" class="mx-2">
                          <v-select v-model="huis.huis_verhuur_start_jaar" :items="bouw_jaarKeuzes" item-value="jaar_nr"
                            item-text="jaar_oms" menu-props="auto" label="Start rent year" dense></v-select>
                        </v-col>
                      </v-row>

                      <v-row no-gutters v-for="(netpRecord, i) in huis.netp" :key="i">
                        <v-combobox v-model="netpRecord.neigSelected" :items="netpRecord.neig" multiple
                          :label="netpRecord.netptaal_oms" class="mx-2"></v-combobox>
                      </v-row>


                      <v-btn class="primary ma-2" x-small @click="saveHuisCard2">Save</v-btn>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="px-1">
                    <updHuisProp1 :huis_encrid="huis_encrid" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <updHuisFeratel :huis_encrid="huis_encrid" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Distances<v-spacer></v-spacer>
                        <v-btn class="primary ma-2" x-small @click="addHsaf(huis.huis_encrid)">Add Distance</v-btn>
                      </v-card-title>

                      <v-simple-table dense>
                        <template v-slot:default>
                          <tbody>
                            <tr v-for="(hsafRecord, i) in huis.hsaf" :key="i">
                              <td>{{ hsafRecord.afsttaal_oms }}</td>
                              <td>{{ hsafRecord.hsaf_oms }}</td>
                              <td>{{ hsafRecord.hsaf_afstand }}</td>
                              <td><v-btn v-if="hsafRecord.rmHsaf === 'Yes'" text icon
                                  @click="rmHsaf(hsafRecord.hsaf_encrid)"><v-icon
                                    small>mdi-trash-can-outline</v-icon></v-btn></td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <addHsaf ref="addHsaf" @updateData="updateData"></addHsaf>
                      <rmHsaf ref="rmHsaf" @updateData="updateData"></rmHsaf>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Sales partners
                        <v-spacer></v-spacer>
                        <v-col cols="1" class="px-1">
                          <btn_audit table="hsip" :encrid="huis.huis_encrid" :size=30 tooltip="audit of partners" />
                        </v-col>
                      </v-card-title>
                      <v-container>
                        <v-row no-gutters v-for="(hsipRecord, i) in huis.inpt" :key="i" class="flex">

                          <v-col v-if="hsipRecord.inpt_url" cols="3" class="hsipline_markup flex">
                            <div v-if="hsipRecord.hsip_tabel !== 'vfy'"><a :href=hsipRecord.inpt_url target="_blank">{{
                                hsipRecord.inpt_naam }}</a></div>
                            <div v-else @click="loadVfyPage(hsipRecord.inpt_url)"><a><u>{{ hsipRecord.inpt_naam
                                  }}</u></a></div>
                            <div class="last-item">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small text icon @click="copyToClipboard(hsipRecord.inpt_url)" v-bind="attrs"
                                    v-on="on">
                                    <v-icon small>mdi-content-copy</v-icon>
                                  </v-btn>
                                </template>
                                <span>copy url</span>
                              </v-tooltip>
                            </div>
                          </v-col>
                          <v-col v-else cols="3" class="hsipline_markup">{{ hsipRecord.inpt_naam }}</v-col>

                          <v-col cols="1" v-if="hsipRecord.hsip_tabel !== 'vfy'">
                            <v-checkbox v-model="hsipRecord.hsip_publish" hide-details dense
                              :disabled="hsipRecord.hsip_disabled"
                              @click="updHsip(hsipRecord.hsip_tabel, hsipRecord.hsip_encrid, hsipRecord.hsip_publish)"></v-checkbox>
                          </v-col>
                          <v-col cols="1" v-else></v-col>

                          <v-col cols="3" class="hsipline_markup">
                            <v-chip small :color=hsipRecord.hsip_status_kleur> {{ hsipRecord.hsip_status }} </v-chip>
                          </v-col>
                          <v-col cols="5" class="hsipline_markup flex">
                            <div>{{ hsipRecord.inpt_id }}</div>
                            <div class="last-item mr-4">
                              <v-btn small v-if="hsipRecord.hsip_tabel === 'hsbc'" text icon
                                @click="updHsbc(hsipRecord.hsip_encrid)">
                                <v-icon small>mdi-wrench</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- complaints start here -->
                <v-row>
                  <v-col cols="12" class="px-1">
                    <huis_hnlp :huis_encrid="huis_encrid" />
                  </v-col>
                </v-row>
                <!-- complaints stops here -->



                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <div style="cursor:default">
                        <v-card-title>Damages<v-spacer></v-spacer>
                          <v-btn class="primary ma-2" x-small @click="showHosm(huis.huis_encrid)"
                            v-if="huis.numberOfClaims > 0">Details</v-btn>
                        </v-card-title>
                        <v-row no-gutters>
                          <v-col cols="12" class="px-5">Total number of damage claims {{ huis.numberOfClaims }}</v-col>
                        </v-row>
                        <v-row cols="12" no-gutter dense class="px-5 mt-5">
                          <v-col cols="3">
                            <v-text-field v-model.lazy="huis.claimed" readonly dense label="Claimed" prefix="€"
                              class="pt-1 text-field-style text-grey"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model.lazy="huis.insurer" readonly dense label="Insurer" prefix="€"
                              class="pt-1 pl-3 text-field-style text-grey"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model.lazy="huis.leniency" readonly dense label="Leniency" prefix="€"
                              class="pt-1 pl-3 text-field-style text-grey"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model.lazy="huis.in_house" readonly dense label="In House" prefix="€"
                              class="pt-1 pl-3 text-field-style text-grey"></v-text-field>
                          </v-col>                          
                        </v-row>
                      </div>
                      <v-row><v-col></v-col></v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- complaints start here -->
                <v-row>
                  <v-col cols="12" class="px-1">
                    <huis_hokl :huis_encrid="huis_encrid" />
                  </v-col>
                </v-row>
                <!-- complaints stops here -->

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <div style="cursor:default">
                        <v-card-title>Reviews<v-spacer></v-spacer>
                          <v-btn class="primary ma-2" x-small @click="showRevw(huis.huis_encrid)"
                            v-if="reviews.nrOfReviews > 0">Details</v-btn>
                        </v-card-title>
                        <v-row no-gutters>
                          <v-col cols="6" class="px-5">Total number of reviews</v-col>
                          <v-col cols="3" class="px-0">{{ reviews.nrOfReviewsInternal }}</v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col cols="6" class="px-5">Overall average score</v-col>
                          <v-col cols="3" class="px-0">{{ reviews.averageScoreInternal }}</v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                          <v-col cols="6" class="px-5">Total number of published reviews</v-col>
                          <v-col cols="3" class="px-0">{{ reviews.nrOfReviewsPublished }}</v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col cols="6" class="px-5">Average score published reviews</v-col>
                          <v-col cols="3" class="px-0">{{ reviews.averageScorePublished }}</v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2 mb-4">
                          <v-col cols="6" class="px-5">Overall average rating</v-col>
                          <v-col cols="3" class="px-0"><v-rating readonly v-model="reviews.averageStars"
                              dense></v-rating></v-col>
                        </v-row>
                      </div>
                      <v-divider class="ml-5 mr-4"></v-divider>
                      <span class="br_medium"></span>
                      <div v-if="reviews.read_only == false"> <!-- not read only -->
                        <v-row no-gutters>
                          <v-col cols="3" class="px-5">
                            <v-menu v-model="menuReviewResetDate" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" readonly offset-y min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field ref="test" v-model="reviewResetDateDMY" label="Reset date" v-bind="attrs"
                                  v-on="on" dense clearable :readonly=false></v-text-field>
                              </template>
                              <v-date-picker v-model="reviews.reviewResetDateISO" v-bind:first-day-of-week="1"
                                v-on:input="reviewResetDateDMY = $moment(reviews.reviewResetDateISO).format('DD-MM-YYYY'); menuReviewResetDate = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="3" class="px-0"></v-col>
                          <v-col cols="4" class="px-0">
                            <v-btn class="primary" x-small v-on:click="saveReviewResetDate">Save</v-btn>
                            <span style="margin-left:10px;" class="ptr">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-avatar color="primary" size=22 v-bind="attrs" v-on="on"><span
                                      class="white--text text-h6">?</span></v-avatar>
                                </template>
                                <span v-if="reviewResetDateDMY == ''">This date is empty, <b>ALL</b> reviews will be send
                                  to the
                                  website</span>
                                <span v-else>Only reviews created <b>AFTER</b> {{ this.reviewResetDateDMY }} will be send
                                  to the
                                  website</span>
                              </v-tooltip>
                            </span>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else style="cursor:default"> <!-- read only -->
                        <v-row cols="12" no-gutters>
                          <v-col cols="6" class="px-5">Review reset date</v-col>
                          <v-col cols="3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <div v-if="reviewResetDateDMY !== ''">
                                  <span v-on="on">{{ $moment(reviews.reviewResetDateISO).format('DD-MM-YYYY') }}</span>
                                </div>
                                <div v-else>
                                  <span v-on="on">not set</span>
                                </div>
                              </template>
                              <span v-if="reviewResetDateDMY == ''">This date is not set, <b>ALL</b> reviews will be send
                                to the
                                website</span>
                              <span v-else>Only reviews created <b>AFTER</b>
                                {{ $moment(reviews.reviewResetDateISO).format('DD-MM-YYYY') }} will be send to the
                                website</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <span class="br_medium"></span>
                      </div>

                      <span class="br_medium"></span>

                      <v-row no-gutters v-if="reviews.nrOfReviews > 0">
                        <v-col cols="12" class="px-2">
                          <v-data-table class="elevation-1" dense :headers="getHeaders()" :items="reviews.summary"
                            :disable-pagination=true hide-default-footer>
                            <template v-slot:item="reviews">
                              <tr>
                                <td>{{ reviews.item.review_source }}</td>
                                <td><v-layout justify-end>{{ reviews.item.review_number }}</v-layout></td>
                                <td><v-layout justify-end>{{ reviews.item.review_average }}</v-layout></td>
                                <td><v-layout justify-center><v-rating readonly v-model="reviews.item.review_stars"
                                      dense></v-rating></v-layout></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-2 mb-4">
                        <v-col cols="12" class="px-5" style="font-size: small !important;">Revyoos state: {{
                          huis.revyoos_state
                          }}</v-col>
                      </v-row>

                    </v-card>
                  </v-col>
                </v-row>

                <updHsbc ref="updHsbc"></updHsbc>
              </v-container>
            </v-col>

            <v-col cols="8" class="px-1"> <!-- Rechts -->
              <v-container>
              <v-row v-if="huis.turnover.length!==0">
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-card-text>
                      <YearTurnover :turnover="huis.turnover" :reverse="true" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Unit {{ planCode }} {{ hspl.plan_ical }} {{ hspl.huis_codes }}
                        <v-btn v-if="getPlan.rmHspl === true" text icon @click="rmHspl(getPlan.hspl_encrid)"><v-icon
                            small>mdi-trash-can-outline</v-icon></v-btn>
                        <v-btn class="mx-3" :disabled="getPlan.jaar === new Date().getFullYear() - 2"
                          @click="getPlanning(planCode, getPlan.jaar - 1)" x-small
                          color="primary"><v-icon>mdi-chevron-left</v-icon></v-btn>
                        {{ getPlan.jaar }}
                        <v-btn class="mx-3" :disabled="getPlan.jaar === new Date().getFullYear() + 2"
                          @click="getPlanning(planCode, getPlan.jaar + 1)" x-small
                          color="primary"><v-icon>mdi-chevron-right</v-icon></v-btn>
                        {{ hspl.plan_to_code }} {{ hspl.plan_to_naam }}
                        <v-spacer></v-spacer>
                        <v-btn class="primary ma-2" x-small
                          @click="addHeho(huis.huis_encrid)">Add Host
                          booking</v-btn>
                        <v-btn class="primary ma-2" x-small @click="showLegend = !showLegend">Legend</v-btn>
                        <v-btn class="primary ma-2" x-small @click="onHprs(getPlan.hspl_encrid)">Restrictions</v-btn>
                        <v-btn v-if="getPlan.showPlsc === 'Yes'" class="primary ma-2" x-small
                          @click="onPlsc(getPlan.hspl_encrid)">Key codes</v-btn>
                        <v-btn class="primary ma-2" x-small @click="updHspl(getPlan.hspl_encrid)">Update Unit</v-btn>
                        <v-btn class="primary ma-2" x-small @click="addHspl(huis.huis_encrid)">Add Unit</v-btn>
                      </v-card-title>
                      <v-container>
                        <rmHspl ref="rmHspl" @updateData="updateData"></rmHspl>
                        <addHspl ref="addHspl" @updateData="updateData"></addHspl>
                        <addHeho ref="addHeho" @updateData="updateData"></addHeho>
                        <updHspl ref="updHspl" @updateData="updateData"></updHspl>
                        <onHprs ref="onHprs" @reloadHuis="reloadHuis"/>
                        <onPlsc ref="onPlsc"></onPlsc>
                        <v-row>
                          <v-col cols="1" v-show="moreThan1HsplRecord">
                            <div class="red--text" style="font-size: 12px">{{ hspl.huis_is_combi }}</div>
                            <table border="0" cellspacing="0" cellpadding="0" class="huisHspl">
                              <tr v-for="huisHspl in huis.hspl" :key="huisHspl.plan_code">
                                <td @click="getPlanning(huisHspl.plan_code, getPlan.jaar)" style="font-size: 12px">
                                  {{ huisHspl.plan_code }}</td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col cols="11">
                            <table border="0" cellspacing="0" cellpadding="0">
                              <tr v-for="planMaand in getPlan.planMaanden" :key="planMaand.maand">
                                <td style="font-size: 12px">{{ planMaand.maand }}</td>
                                <td @click="clickPlan(planRecord.datum, planRecord.tabel, planRecord.encrid)"
                                  :class="[planRecord.achtergrond, planRecord.gewicht, planRecord.fontkleur]"
                                  v-for="planRecord in planMaand.maandDagen" :key="planRecord.dag">{{ planRecord.dag }}
                                </td>
                              </tr>
                            </table>
                            <updPlan ref="updPlan"></updPlan>

                            <updRmvHprs ref="updRmvHprs" @reloadHuis="reloadHuis"></updRmvHprs>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-row>
                        <v-col cols="1"></v-col>
                        <v-col cols="11" style="display: flex; flex-direction: row; gap: 20px;">
                          <div>
                            Rent License: {{ hspl.plan_verhvergun_stat }} {{ hspl.plan_verhvergun_ref }}
                          </div>
                          <div>
                            Energy Label: {{ hspl.plan_energie_label }}
                          </div>
                          <div v-if="hspl.plan_operto_id !== ''">
                            Operto: {{ hspl.plan_operto_id }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-container class="pl-8 pr-8" v-if="showLegend">
                          <div style="display: flex; flex-direction: row; align-items: center;">
                            <div>Legend</div> <v-divider class="ml-2 mr-2"></v-divider>
                          </div>
                          <div
                            style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: space-between; padding-top: 10px; padding-bottom: 10px; padding-left: 20px">
                            <div v-for="legendaRecord in legenda.legenda" :key="legendaRecord.achtergrond"
                              style="display: flex; flex-direction: row; align-items: center; padding-top: 5px; padding-bottom: 10px; width: 275px; ">
                              <div :class="legendaRecord.achtergrond" style="width: 30px; height: 30px; min-width: 30px; flex: 0 0 30px;"></div>
                              <div class="ml-2">{{ legendaRecord.oms }}</div>
                            </div>
                          </div>
                        </v-container>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Photos &nbsp;
                        <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="primary" @click="updateData()" v-bind="attrs" v-on="on">mdi-reload</v-icon>
                                </template>
                                <span>Reload photo's</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="primary" @click="downloadAllHsftZip(huis.huis_encrid)" v-bind="attrs" v-on="on">mdi-download</v-icon>
                                </template>
                                <span>Download all photos as ZIP</span>
                              </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-checkbox v-model="huis.huis_winter_foto_volgorde" @change="winterfoto()"
                          label="Winter foto order"></v-checkbox>



                        <v-btn v-if="huis.huis_media === 'Yes' && huis.huis_winter_foto_volgorde === true"
                          class="primary ma-2" x-small @click="orderHsft(huis.huis_encrid, 'winter')">Sort Winter
                          photos</v-btn>
                        <v-btn v-if="huis.huis_media === 'Yes'" class="primary ma-2" x-small
                          @click="orderHsft(huis.huis_encrid, 'summer')">Sort photos (Summer)</v-btn>
                        <v-btn v-if="huis.huis_media === 'Yes'" class="primary ma-2" x-small
                          @click="addHsft2(huis.huis_encrid)">Add
                          1 photo</v-btn>
                        <v-btn v-if="huis.huis_media === 'Yes' && canCopyHsft" class="primary ma-2" x-small
                          @click="copyHsft(huis)">Copy photo's</v-btn>
                        <!--
                        <v-btn v-if="huis.huis_media === 'Yes'" class="primary ma-2" x-small
                          @click="bulkDelHsft(huis)">Bulk delete
                          Photo's</v-btn>-->


                          <!--
                        <v-btn v-if="huis.huis_media === 'Yes' && huis.hsft_deleted"
                          class="primary ma-2" x-small @click="viewDelHsft(huis.huis_encrid)">View deleted
                          photo's</v-btn> -->

                        <!---->
                        <!--
                        <v-dialog v-model="dialog" width="1250">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn class="primary ma-2" x-small v-bind="attrs" v-on="on">
                              Add multiple photo's
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Add photo's
                            </v-card-title>
                            <div class="pa-5">
                              <HsftDropzone :huis-row-id="huis.huis_encrid" />
                            </div>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" @click="dialog = false; updateData()">
                                Close
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        -->
                        <v-dialog v-model="dialogphp" width="1250">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn class="primary ma-2" x-small v-bind="attrs" v-on="on">
                              Add multiple photo's
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Add photo's
                            </v-card-title>
                            <div class="pa-5">
                              <HsftDropzonePhp :huis-row-id="huis.huis_encrid" :gebr-encrid="getCurrentUser()" :huis-nr="huis.huis_nr" :upload-url="huis.hsft_upload_url" />
                            </div>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" @click="dialogphp = false; updateData()">
                                Close
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <!--
                        <v-menu open-on-hover offset-y v-if="huis.huis_media === 'Yes' && this.getAuth('carlo')">
                          <template v-slot:activator="{ attrs, on }">
                            <v-btn class="primary ma-5" v-bind="attrs" v-on="on" x-small>
                              Photo actions
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item link
                              v-if="huis.huis_media === 'Yes' && huis.huis_winter_foto_volgorde === true"
                              @click="orderHsft(huis.huis_encrid, 'winter')">
                              <v-list-item-title> Sort Winter photos </v-list-item-title>
                            </v-list-item>
                            <v-list-item link @click="orderHsft(huis.huis_encrid, 'summer')">
                              <v-list-item-title> Sort photos (Summer) </v-list-item-title>
                            </v-list-item>
                            <v-list-item link @click="addHsft2(huis.huis_encrid)">
                              <v-list-item-title> Add 1 photo </v-list-item-title>
                            </v-list-item>
                            <v-list-item link v-if="huis.huis_media === 'Yes' && this.getAuth('carlo')" @click="copyHsft(huis)">
                              <v-list-item-title> Copy photo's </v-list-item-title>
                            </v-list-item>
                            <v-list-item link v-if="huis.hsft_processing" @click="viewProcessingHsft(huis.huis_encrid)">
                              <v-list-item-title> Processing status </v-list-item-title>
                            </v-list-item>

                            <v-list-item link @click="bulkDelHsft(huis)">
                              <v-list-item-title> Bulk delete Photo's </v-list-item-title>
                            </v-list-item>
                            <v-list-item link v-if="huis.hsft_deleted" @click="viewDelHsft(huis.huis_encrid)">
                              <v-list-item-title> View deleted photo's </v-list-item-title>
                            </v-list-item>


                          </v-list>
                        </v-menu>-->
                        <v-btn v-if="editPhotographer"
                          class="primary ma-2" x-small @click="viewPhotoAssignments(huis.huis_encrid)">Photo assignments</v-btn>

                        <v-btn v-if="huis.huis_media === 'Yes' && huis.hsft_processing"
                          class="primary ma-2" x-small @click="viewProcessingHsft(huis.huis_encrid)">Upload Errors</v-btn>
                        <v-btn v-if="huis.huis_media === 'Yes'" class="primary ma-2" x-small
                          @click="viewAllHsft(huis.huis_encrid)">Photo presentation</v-btn>

                          <btn_audit table="hsft" :encrid="huis.huis_encrid" :size=30
                          tooltip="audit of accommodation - Photos" />
                      </v-card-title>
                      <v-container fluid id="fotoContainer">
                        <v-row v-if="huis.huis_media === 'Yes'" no-gutters>
                          <v-col v-for="p in huis.hsft_aant" :key="p" id="content" class="d-flex child-flex ma-2"
                            cols=2>
                            <figure>
                              <svg v-if="huis.hsft[parseInt(p) - 1].hsft_bewerkt == 'Adjusted with AI'" viewBox="0 0 24 24" role="presentation" class="ai_adjusted"><path d="M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74" style="fill: #f5d502;"></path></svg>
                              <img :src="huis.hsft[parseInt(p) - 1].hsft_foto" class="px-1"
                                @click="updHsft(huis.hsft[parseInt(p) - 1].hsft_encrid)"
                                :title="huis.hsft[parseInt(p) - 1].hsft_tag">
                              <figcaption> {{ huis.hsft[parseInt(p) - 1].hsft_nr }} {{ huis.hsft[parseInt(p) - 1].hsft_tag
                                }}
                                <v-avatar color="error" v-if="huis.hsft[parseInt(p) - 1].hsft_portrait" size=30
                                  class="mx-1">Portr</v-avatar>
                                <v-avatar color="error" v-if="huis.hsft[parseInt(p) - 1].hsft_size_red" size=30
                                  class="mx-1">Size</v-avatar>
                                <v-avatar color="warning" v-if="huis.hsft[parseInt(p) - 1].hsft_size_orange" size=30
                                  class="mx-1">Size</v-avatar>
                                <v-chip color="error" v-if="huis.hsft[parseInt(p) - 1].hsft_no_tag" size=30
                                  class="mx-1">Add photo
                                  tag!</v-chip>
                                <v-avatar color="warning" v-if="huis.hsft[parseInt(p) - 1].hsft_not_43" size=30
                                  class="mx-1">4:3</v-avatar>
                                <v-avatar color="warning" v-if="huis.hsft[parseInt(p) - 1].hsft_not_unique" size=30
                                  class="mx-1">Uniq</v-avatar>
                              </figcaption>
                            </figure>
                          </v-col>
                        </v-row>
                      </v-container>
                      <addHsft2 ref="addHsft2" @updateData="updateData"></addHsft2>
                      <orderHsft ref="orderHsft" @updateData="updateData"></orderHsft>
                      <viewDelHsft ref="viewDelHsft" @updateData="updateData"></viewDelHsft>
                      <viewProcessingHsft ref="viewProcessingHsft"></viewProcessingHsft>
                      <downloadAllHsftZip ref="downloadAllHsftZip"></downloadAllHsftZip>
                      <viewPhotoAssignments ref="viewPhotoAssignments"></viewPhotoAssignments>
                      <copyHsft ref="copyHsft" @updateData="updateData"></copyHsft>
                      <updHsft ref="updHsft" @updateData="updateData"></updHsft>
                      <bulkDelHsft ref="bulkDelHsft" @updateData="updateData" />
                      <viewAllHsft ref="viewAllHsft" @updateData="updateData" />
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Video / 360 degree presentation<v-spacer></v-spacer>
                        </v-card-title>
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="6" class="px-1">
                              <v-text-field v-model="huis.huis_vimeo_url" label="Vimeo URL"
                                :readonly="huis.huis_video_readonly"></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="6" class="px-1">
                              <v-text-field v-model="huis.huis_cloudflare_video_url" label="Cloudflare video URL"
                                :readonly="huis.huis_video_readonly"></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="6" class="px-1">
                              <v-text-field v-model="huis.huis_360_url" label="360 degree presentation URL"
                                :readonly="huis.huis_video_readonly"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                        <v-row no-gutters>
                          <v-col cols="1" class="px-1">
                            <v-btn class="primary ma-2" x-small @click="saveHuisCard3"
                              :disabled="huis.huis_video_readonly">Save</v-btn>
                          </v-col>
                        </v-row>

                      <!-- </v-form> -->
                    </v-card>
                  </v-col>
                </v-row>


                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Sentences<v-spacer></v-spacer>
                        <v-btn class="primary ma-2" x-small @click="addHszn3(huis.huis_encrid)">Add Sentence</v-btn>
                        <btn_audit table="hszn" :encrid="huis.huis_encrid" :size=30
                          tooltip="audit of accommodation - Sentences" />
                      </v-card-title>

                      <v-simple-table dense>
                        <template v-slot:default>
                          <tbody>
                            <tr v-for="(hsznRecord, i) in huis.hszn" :key="i">
                              <td>{{ hsznRecord.zinn_zinn }}<span v-if="huis.showNumbers" class="ml-2">({{
                                  hsznRecord.zinn_nr }})</span></td>
                              <td><v-btn text icon @click="rmHszn(hsznRecord.hszn_encrid)"><v-icon
                                    small>mdi-trash-can-outline</v-icon></v-btn></td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <addHszn ref="addHszn" @updateData="updateData"></addHszn>
                      <addHszn3 ref="addHszn3" @updateData="updateData"></addHszn3>
                      <rmHszn ref="rmHszn" @updateData="updateData"></rmHszn>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="px-1">
                    <v-card>
                      <v-card-title>Contract<v-spacer></v-spacer><v-btn class="primary ma-2" x-small
                          @click="addHspt(huis.huis_encrid)">Add Contract</v-btn></v-card-title>

                      <v-tabs v-model="hsptDummy">
                        <v-tab v-for="(hsptRecord, i) in huis.hspt" :key="i"> {{ hsptRecord.hspt_titel }} </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="hsptDummy" dense>
                        <v-tab-item v-for="(hsptRecord, i) in huis.hspt" :key="i">
                          <v-card>
                            <v-container>
                              <v-row no-gutters>
                                <v-col cols="3" class="pa-2">
                                  <v-select v-model="hsptRecord.cttp_nr" required :items="hsptRecord.cttp_nrKeuzes"
                                    item-value="cttp_nr" item-text="cttptaal_oms" label="Contract type" dense
                                    :rules="cttp_nrRules" :readonly="!contract_update_enabled"></v-select>
                                </v-col>
                                <v-col cols="1" class="pa-2">
                                  <v-select v-model="hsptRecord.stat_code" :items="hsptRecord.stat_codeKeuzes" label="Status" dense></v-select>
                                </v-col>
                                <v-col cols="2" class="pa-2">
                                  <v-select v-model="hsptRecord.hspt_prs_strct" :items="hsptRecord.hspt_prs_strctKeuzes"
                                    label="Price" dense></v-select>
                                </v-col>
                                <v-col cols="2" class="px-1 pt-2">
                                  <btn_audit table="hspt" :encrid="hsptRecord.hspt_encrid" :size=30 tooltip="audit of contract" />
                                  <v-btn class="primary ma-2" x-small @click="updHsnp(hsptRecord.hspt_encrid)">Night prices</v-btn>
                                </v-col>
                                <v-col cols="2" class="ml-4 pt-3"
                                  v-if="hsptRecord.hspt_prs_strct === 'Night' && hsptRecord.hasPriorityPrice">
                                  <v-icon color="red" class="ml-5">mdi-alert-circle-outline</v-icon><span class="ml-1"
                                    style="color: red; font-weight: 600;">Priority prices</span>
                                </v-col>
                                <v-col cols="1" class="pa-2" v-if="hsptRecord.hspt_prs_strct === 'LOS'">
                                  <v-btn class="primary ma-2" x-small @click="updHsfp(hsptRecord.hspt_encrid)">LOS
                                    prices</v-btn>
                                </v-col>
                              </v-row>

                              <v-row no-gutters>
                                <v-col cols="2" class="px-2">
                                  <v-menu v-model="hsptRecord.hspt_aank_van_datMenu" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="hsptRecord.hspt_aank_van_dat" label="Arrival from"
                                        v-on="on" dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="hsptRecord.hspt_aank_van_dat2" :first-day-of-week="1"
                                      @input="hsptRecord.hspt_aank_van_dat = $moment(hsptRecord.hspt_aank_van_dat2).format('DD-MM-YYYY'); hsptRecord.hspt_aank_van_datMenu = false"></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="2" class="px-2">
                                  <v-menu v-model="hsptRecord.hspt_aank_tm_datMenu" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="hsptRecord.hspt_aank_tm_dat"
                                        label="Arrival up to and including" v-on="on" dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="hsptRecord.hspt_aank_tm_dat2" :first-day-of-week="1"
                                      @input="hsptRecord.hspt_aank_tm_dat = $moment(hsptRecord.hspt_aank_tm_dat2).format('DD-MM-YYYY'); hsptRecord.hspt_aank_tm_datMenu = false"></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col v-if="hsptRecord.hspt_rm == 'yes'">
                                  <v-btn text icon @click="rmHspt(hsptRecord.hspt_encrid)"><v-icon
                                      small>mdi-trash-can-outline</v-icon></v-btn>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col cols="2" class="px-2">
                                  <v-menu v-model="hsptRecord.hspt_publ_bijdrage_vanaf_datMenu"
                                    :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                                    readonly offset-y min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="hsptRecord.hspt_publ_bijdrage_vanaf_dat"
                                        label="Publication costs starts" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="hsptRecord.hspt_publ_bijdrage_vanaf_dat2"
                                      :first-day-of-week="1"
                                      @input="hsptRecord.hspt_publ_bijdrage_vanaf_dat = $moment(hsptRecord.hspt_publ_bijdrage_vanaf_dat2).format('DD-MM-YYYY'); hsptRecord.hspt_publ_bijdrage_vanaf_datMenu = false"></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="3">
                                  <v-text-field v-model="hsptRecord.hspt_publ_bijdrage_bedrag"
                                    :prefix=hsptRecord.valu_code_prs label="Publication costs"
                                    type="number"></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row no-gutters>
                                <v-col cols="2" class="px-2">
                                  <v-select v-model="hsptRecord.hspt_rent_aant_pers" required
                                    :items="hsptRecord.eppr_nrKeuzes" item-value="eppr_nr" item-text="epprtaal_oms"
                                    label="Default Price is for Persons"></v-select>
                                </v-col>
                                <v-col cols="3" v-if="hsptRecord.hspt_rent_aant_pers > 1">
                                  <v-text-field v-model="hsptRecord.hspt_rent_extra_pers_pppn_ink"
                                    :prefix=hsptRecord.valu_code_prs label="Purchase PPPN for every person above"
                                    type="number"></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pl-2" v-if="hsptRecord.hspt_rent_aant_pers > 1">
                                  <v-text-field v-model="hsptRecord.hspt_rent_extra_pers_pppn_verk"
                                    :prefix=hsptRecord.valu_code_prs label="Sales PPPN for every person above"
                                    type="number"></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row no-gutters>
                                <v-col cols="2" class="pa-2">
                                  <v-select v-model="hsptRecord.hspt_flexprijs_perc" required
                                    :items="hsptRecord.flpr_nrKeuzes" item-value="flpr_nr" item-text="flprtaal_oms"
                                    label="Smart pricing percentage" dense></v-select>
                                </v-col>

                                <v-col v-if="hsptRecord.hspt_flexprijs_dat != null" cols="2" class="pa-2">
                                  <v-text-field v-model="hsptRecord.hspt_flexprijs_dat" label="Smart pricing start date"
                                    readonly dense></v-text-field>
                                </v-col>
                              </v-row>
                              <!-- <v-row no-gutters v-if="hsptRecord.stat_code==='DP'">
                                <v-col cols="6" class="pa-2">
                                    <b>DP Action</b>
                                    <actie ref="actie2" :key="actionKey" :huis_encrid="huis.huis_encrid" :huis_actie_datum="huis.huis_actie_datum_2" :huis_actie_opm="huis.huis_actie_opm" :inital_state="huis.huis_actie_datum_2 === ''" :huis_code="huis.huis_code" @updateData="updateAction"/>
                                </v-col>
                              </v-row> -->
                              <v-dialog persistent v-model="dp_action" width="800px">
                                <v-card>
                                    <v-card-title>Action for DP</v-card-title>
                                    <v-card-text>
                                        <v-row no-gutters class="pb-2">
                                            <v-col cols="4" class="px-2">
                                                <v-menu v-model="dat1menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="actie_datum" label="Action date" v-on="on" readonly></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="huis.huis_actie_datum_2" :first-day-of-week="1" @input="actie_datum = $moment(huis.huis_actie_datum_2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="8" class="px-2">
                                                <v-text-field v-model="huis.huis_actie_opm" label="Remark"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn class="mr-2" color="primary" x-small @click="actionSave" :disabled="actie_datum===''||huis.huis_actie_opm===''">Continue</v-btn>
                                        <v-btn class="mr-2" color="error" x-small @click="cancelHsptSave">Cancel</v-btn>
                                    </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-container>
                            <v-row no-gutters>
                              <v-col cols="1" class="px-2">
                                <v-btn class="primary ma-2" x-small @click="saveHspt(hsptRecord)">Save</v-btn>
                              </v-col>
                            </v-row>

                            <v-card-title>Guarantee periods<v-spacer></v-spacer><v-btn class="primary ma-2" x-small
                                @click="addHpgp(hsptRecord.hspt_encrid)">Add Guarantee period</v-btn></v-card-title>

                            <div v-if="thpgp.length !== 0">
                              <v-select v-model="hpgp_periodetype" clearable
                                :items="[{ code: -1, oms: 'Invoiced periods' }, { code: 1, oms: 'Future periods' }]"
                                item-value="code" item-text="oms" label="Periode filter" class="thgp-select"></v-select>
                            </div>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr class="table-header">
                                    <td>Date from</td>
                                    <td>Date until</td>
                                    <td>Amount</td>
                                    <td>Invoice</td>
                                    <td>Actions</td>
                                  </tr>
                                  <tr v-for="(hpgpRecord, j) in filtered_thpgp" :key="j">
                                    <td>{{ hpgpRecord.hpgp_van_dat }}</td>
                                    <td>{{ hpgpRecord.hpgp_tm_dat }}</td>
                                    <td>{{ hpgpRecord.hpgp_bedrag }}</td>
                                    <td v-if="hpgpRecord.hefc_nr !== 0">{{ hpgpRecord.hefc_nr }}</td>
                                    <td v-else></td>
                                    <td><v-btn v-if="hpgpRecord.hpgp_rm == true" text icon
                                        @click="rmHpgp(hpgpRecord.hpgp_encrid)"><v-icon
                                          small>mdi-trash-can-outline</v-icon></v-btn></td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>

                            <v-card-title>Additional Costs<v-spacer></v-spacer><v-btn class="primary ma-2" x-small
                                @click="addHpbk(hsptRecord.hspt_encrid)">Add Costs</v-btn>
                              <btn_audit table="hpbk" :encrid="hsptRecord.hspt_encrid" :size=30
                                tooltip="audit of accommodation - Contract Additional costs" />
                            </v-card-title>
                            <v-container>
                              <span class="mx-2">Currency : {{ hsptRecord.valu_code_ksttp }} </span>

                              <v-row no-gutters>
                                <v-col cols="12">
                                  <v-data-table class="elevation-1" dense :items="hsptRecord.hpbk"
                                    :disable-pagination=true hide-default-footer>
                                    <template v-slot:item="hpbkRecord">
                                      <tr>
                                        <td><span v-if="huis.showNumbers">{{ hpbkRecord.item.kstp_nr }}</span><span class="mx-2">-</span>{{ hpbkRecord.item.ktpttaal_oms }} </td>
                                        <td>{{ hpbkRecord.item.ktpt_type }}</td>
                                        <td>{{ hpbkRecord.item.hpbk_betaling }}</td>
                                        <td>{{ hpbkRecord.item.hpbk_van_tm_dat }}</td>
                                        <td>{{ hpbkRecord.item.hpbk_purchase_zin }}</td>
                                        <td>{{ hpbkRecord.item.hpbk_sales_zin }}</td>
                                        <td>
                                            <v-btn text icon @click="rmHpbk(hpbkRecord.item.hpbk_encrid)" v-if="!hpbkRecord.item.hpbk_details">
                                                <v-icon small>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                            <v-btn text icon @click="viewHpbkDetails(hpbkRecord.item.kstp_nr, hsptRecord.hspt_encrid, hpbkRecord.item.hpbk_regels)" v-if="hpbkRecord.item.hpbk_details">
                                                <v-icon small>mdi-pencil-outline</v-icon>
                                            </v-btn>
                                        </td>
                                      </tr>
                                    </template>
                                  </v-data-table>

                                </v-col>
                              </v-row>
                            </v-container>
                            <v-card-title>Host booking restrictions<v-spacer></v-spacer><v-btn class="primary ma-2"
                                x-small @click="addHpbr(hsptRecord.hspt_encrid)">Add Host booking restriction</v-btn>
                              <btn_audit table="hpbr" :encrid="hsptRecord.hspt_encrid" :size=30
                                tooltip="audit of accommodation - Booking restriction" />
                            </v-card-title>

                            <v-container>
                              <v-simple-table class="elevation-1" dense>
                                <template v-slot:default>
                                  <tbody>
                                    <tr v-for="(hpbrRecord, k) in hsptRecord.hpbr" :key="k">
                                      <td>{{ hpbrRecord.hpbr_oms }}</td>
                                      <td><v-btn text icon @click="rmHpbr(hpbrRecord.hpbr_encrid)"><v-icon
                                            small>mdi-trash-can-outline</v-icon></v-btn></td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-container>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                      <addHpgp ref="addHpgp" @updateData="updateData"></addHpgp>
                      <addHpbr ref="addHpbr" @updateData="updateData"></addHpbr>
                      <rmHpgp ref="rmHpgp" @updateData="updateData"></rmHpgp>
                      <addHpbk ref="addHpbk" @reloadHpbk="reloadHpbk"></addHpbk>
                      <viewHpbkDetails ref="viewHpbkDetails" @updateData="updateData" :key="refreshCount"/>
                      <rmHpbk ref="rmHpbk" @updateData="updateData"></rmHpbk>
                      <rmHpbr ref="rmHpbr" @updateData="updateData"></rmHpbr>
                      <addHspt ref="addHspt" @updateData="updateData"></addHspt>
                      <rmHspt ref="rmHspt" @updateData="updateData"></rmHspt>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pa-1 mb-4">
                    <priceUpdates :huis_encrid="huis_encrid" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pa-1 mb-4">
                    <discounts :huis_encrid="huis_encrid" />
                  </v-col>
                </v-row>

                <!-- Changes on this house -->
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <countHowz :entity="'huis'" :encrid="huis_encrid" />
                  </v-col>
                </v-row>
                <!-- Pending rebookings on this house -->
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <countHomb :entity="'huis'" :encrid="huis_encrid" />
                  </v-col>
                </v-row>
                <!-- Rebookings on this house -->
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <v-card>
                      <v-card-title>Rebookings ({{ huis.numberOfRebookings }})
                        <v-spacer></v-spacer>
                        <v-btn class="primary ma-2" x-small @click="showDetails('huis-ovb', huis_encrid)" v-if="huis.numberOfRebookings > 0" >Details</v-btn>
                      </v-card-title>
                      <div style="cursor:default" class="flex px-4 pt-2 pb-4">
                        <div class="column">
                          By guest: <span class="col-value">{{ huis.numberOfRebookingsGuest }}</span>
                        </div>
                        <div class="column">
                          By host: <span class="col-value">{{ huis.numberOfRebookingsHost }}</span>
                        </div>
                        <div class="column">
                          By Villa for You: <span class="col-value">{{ huis.numberOfRebookingsVfy }}</span>
                        </div>
                        <div class="column">
                          By Force Majeure: <span class="col-value">{{ huis.numberOfRebookingsForceMajeure }}</span>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- Cancellations on this house -->
                <v-row>
                  <v-col cols="12" class="pa-1 mt-1">
                    <v-card>
                      <v-card-title>Cancellations ({{ huis.numberOfCancellations }})</v-card-title>
                      <div style="cursor:default" class="flex px-4 pt-2 pb-4">
                        <div class="column">
                          By guest: <span class="col-value">{{ huis.numberOfCancellationsGuest }}</span>
                        </div>
                        <div class="column">
                          By host: <span class="col-value">{{ huis.numberOfCancellationsHost }}</span>
                        </div>
                        <div class="column">
                          By Villa for You: <span class="col-value">{{ huis.numberOfCancellationsVfy }}</span>
                        </div>
                        <div class="column">
                          By Force Majeure: <span class="col-value">{{ huis.numberOfCancellationsForceMajeure }}</span>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
        <m_attm ref="m_attm" @updateNumberOfAttm="updateParentAttmData"></m_attm>
        <nott ref="nott" @updateParentNoteData="updateParentNoteData"></nott>
        <rmHuis ref="rmHuis"></rmHuis>
        <excelOmzet1 ref="excelOmzet1"></excelOmzet1>
        <updFrtt ref="updFrtt"></updFrtt>
        <websitePrice ref="websitePrice"></websitePrice>
        <showICal ref="showICal"></showICal>
        <updateWebsites ref="updateWebsites"></updateWebsites>
      </div>
      <div v-if="loading&&!crash">
        <v-row class="mt-10">
          <v-col cols="12" span="12" align="center">
            <v-progress-circular :width="3" :size="25" color="green" indeterminate></v-progress-circular>
            <span class="markup ml-4">loading accommodation data...</span>
          </v-col>
        </v-row>
      </div>
      <div v-if="!crash&&!loading&&huis.hserNumberOfErrors!==0" class="errorfab" @click="getHser('Error')">{{ huis.hserNumberOfErrors }}</div>
      <div v-if="crash&&!loading">
        <v-row class="mt-10">
          <v-col cols="12" span="12" align="center">
            <v-icon color="red" size="50">mdi-emoticon-sad-outline</v-icon>
            <span class="markup ml-4">Something went wrong. This house cannot be displayed due to missing data.</span>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import flexfield from '@/components/ui/fields/flexfield.vue'
import btn_audit from "@/components/ui/buttons/btn_audit.vue";
import nott from "@/components/nott.vue";
import hser from "@/components/hser.vue";
import updAddress from "@/views/huis/updAddress.vue";
import overruleAddress from "@/views/huis/overruleAddress.vue";
import showMap from "@/views/huis/showMap.vue";
import updHsct from "@/views/huis/hsct/updHsct.vue";
import updHsct2 from "@/views/huis/hsct/updHsct2.vue";
import rmHsct from "@/views/huis/hsct/rmHsct.vue";
import addHsct from "@/views/huis/hsct/addHsct.vue";
import updHsbc from "@/views/huis/hsbc/updHsbc.vue";
import copyHsctToHoct from "@/views/huis/hsct/copyHsctToHoct.vue";
import addHspl from "@/views/huis/hspl/addHspl.vue";
import addHeho from "@/views/huis/heho/addHeho.vue";
import rmHspl from "@/views/huis/hspl/rmHspl.vue";
import updHspl from "@/views/huis/hspl/updHspl.vue";
import updPlan from "@/views/huis/hspl/updPlan.vue";
import onHprs from "@/views/huis/hspl/onHprs.vue";
import onPlsc from "@/views/huis/hspl/plsc/onPlsc.vue";
import updRmvHprs from "@/views/huis/hspl/updRmvHprs.vue";
import addHszn from "@/views/huis/hszn/addHszn.vue";
import addPlts from "@/views/huis/plts/addPlts.vue";
import addHsaf from "@/views/huis/hsaf/addHsaf.vue";
import rmHsaf from "@/views/huis/hsaf/rmHsaf.vue";
import addHszn3 from "@/views/huis/hszn/addHszn3.vue";
import rmHszn from "@/views/huis/hszn/rmHszn.vue";

import updTxts from "@/views/huis/txts/updTxts.vue";
import addHspt from "@/views/huis/hspt/addHspt.vue";
import rmHspt from "@/views/huis/hspt/rmHspt.vue";
import addHpbk from "@/views/huis/hspt/hpbk/addHpbk.vue";
import viewHpbkDetails from "@/views/huis/hspt/hpbk/viewHpbkDetails.vue";
import addHpgp from "@/views/huis/hspt/hpgp/addHpgp.vue";
import addHpbr from "@/views/huis/hspt/hpbr/addHpbr.vue";
import rmHpbk from "@/views/huis/hspt/hpbk/rmHpbk.vue";
import rmHpbr from "@/views/huis/hspt/hpbr/rmHpbr.vue";
import rmHpgp from "@/views/huis/hspt/hpgp/rmHpgp.vue";
import addHsft2 from "@/views/huis/hsft/addHsft2.vue";
import orderHsft from "@/views/huis/hsft/orderHsft.vue";
import viewDelHsft from "@/views/huis/hsft/viewDelHsft.vue";
import viewProcessingHsft from "@/views/huis/hsft/viewProcessingHsft.vue";
import downloadAllHsftZip from "@/views/huis/hsft/downloadAllHsftZip.vue";
import viewPhotoAssignments from "@/views/huis/hsfo/viewPhotoAssignments.vue";
import copyHsft from "@/views/huis/hsft/copyHsft.vue";
import updHsft from "@/views/huis/hsft/updHsft.vue";
import bulkDelHsft from "@/views/huis/hsft/bulkDelHsft.vue";
import viewAllHsft from "@/views/huis/hsft/viewAllHsft.vue";

import rmHuis from "@/views/huis/rmHuis.vue";
import excelOmzet1 from "@/views/huis/ovrz/excelOmzet1.vue";
import updFrtt from "@/views/huis/frtt/updFrtt.vue";
import websitePrice from "@/views/huis/websitePrice.vue";
import showICal from "@/views/huis/showICal.vue";
import updateWebsites from "@/views/huis/updateWebsites.vue";
import qualityCheck from "@/views/huis/qualityCheck.vue";
import m_attm from "@/components/m_attm.vue";
import actie from '@/components/huis/cards/actie.vue';
import huis_hokl from '@/components/huis/cards/complaints.vue';
import huis_hnlp from '@/components/huis/cards/huis_hnlp.vue';
// import HsftDropzone from '@/components/huis/hsft/HsftDropzone.vue';
import HsftDropzonePhp from '@/components/huis/hsft/HsftDropzone6php.vue';

import updHuisProp1 from '@/views/huis/prop/updHuisProp1.vue';
import updHuisFeratel from '@/components/huis/cards/feratel.vue';
import countHomb from '@/components/huov/homb/countHomb.vue';
import countHowz from '@/components/huov/howz/countHowz.vue';
import mxauthorization from '@/mixins/authorization';
import discounts from '@/components/huis/cards/discounts.vue';
import priceUpdates from '@/components/huis/cards/priceUpdates.vue';
import YearTurnover from '@/components/turnover/year_turnover_acco.vue';

import defNavBar from '@/components/ui/navbars/navbar.vue';

import { bus } from "../../main";

export default {
  components: {
    btn_audit,
    m_attm,
    nott,
    hser,
    updAddress,
    overruleAddress,
    showMap,
    updHsct,
    updHsct2,
    rmHsct,
    addHsct,
    updHsbc,
    copyHsctToHoct,
    addHspl,
    addHeho,
    updPlan,
    onHprs,
    onPlsc,
    updRmvHprs,
    rmHspl,
    updHspl,
    addPlts,
    addHszn,
    addHsaf,
    rmHsaf,
    addHszn3,
    rmHszn,
    addHspt,
    rmHspt,
    addHpbk,
    viewHpbkDetails,
    addHpgp,
    addHpbr,
    rmHpbk,
    rmHpbr,
    rmHpgp,
    addHsft2,
    orderHsft,
    viewDelHsft,
    viewProcessingHsft,
    downloadAllHsftZip,
    viewPhotoAssignments,
    copyHsft,
    updHsft,
    bulkDelHsft,
    viewAllHsft,
    updTxts,
    rmHuis,
    excelOmzet1,
    updFrtt,
    websitePrice,
    showICal,
    updateWebsites,
    qualityCheck,
    huis_hokl,
    huis_hnlp,
    flexfield,
    //HsftDropzone,
    HsftDropzonePhp,
    countHomb,
    countHowz,
    updHuisProp1,
    updHuisFeratel,
    discounts,
    actie,
    defNavBar,
    priceUpdates,
    YearTurnover
  },
  props: ['huis_encrid'],
  mixins: [mxauthorization],
  data() {
    return {
      refreshCount: 1,
      // Inline actie popup
      dp_action: false,
      dat1menu: false,
      actie_datum: "",
      keepHspt: {},
      //
      editPhotographer: false,
      canCopyHsft: false,
      huisCard1Valid: false,
      hserErrorsExist: false,
      rental_expert: '',
      hserWarningsExist: false,
      moreThan1HsplRecord: false,
      menuReviewResetDate: false,
      reviewResetDateDMY: '',
      contract_update_enabled: '',
      rdoz_selected: [],
      stat_codeKeuzes: [],
      hstp_nrKeuzes: [],
      bouw_jaarKeuzes: [],
      opties_dvvb_Keuzes: [],
      hgrp_codeKeuzes: [],
      plts_nrKeuzes: [],
      prov_codeKeuzes: [],
      mrkt_nrKeuzes: [],
      hsav_nrKeuzes: [],
      lmterm_nrKeuzes: [],
      aantnacht_maxKeuzes: [],
      tt_vanaf_leeftijdKeuzes: [],
      gebr_codeKeuzes: [],
      tijdKeuzes: [],
      thpgp: [],
      hpgp_periodetype: 1,
      reviews: {},
      quality_check_data: {},
      damages: {},
      address: '',
      loading: true,
      crash: false,
      actionKey: 1,
      huis: {
        huis_encrid: '',
        huis_actie_datum_2: '',
        huis_actie_opm: '',
        huis_code: '',
        huis_combi: '',
        action_items: [],  /* moet pre defined ivm length check */
        hsabCurrent: [], /* moet pre defined ivm length check */
        hsabExpired: [], /* moet pre defined ivm length check */

      },
      getPlan: {},
      hspl: {},
      legenda: {},
      planMaand: [],
      planCode: '',
      flexAirBnbUrl: '',
      flexBookingUrl: '',
      huis_aantpers_maxRules: [
        v => (v && v >= 2) || "Number of persons minimal 2"
      ],
      huis_naamRules: [
        v => (v && v.length >= 3) || "A name is required"
      ],
      huis_adresRules: [
        v => (v && v.length >= 3) || "An address is required"
      ],
      huis_postcodeRules: [
        v => (v && v.length >= 3 && v.length < 8) || "A valid Postcal code is required"
      ],
      huis_plaatsRules: [
        v => (v && v.length >= 3) || "A City code is required"
      ],
      cttp_nrRules: [
        v => !!v || "A Contract type is required"
      ],
      huis_aant_baby_osRules: [
        v => Number.isInteger(Number(v)) || 'The value must be an integer number',
        v => v >= 0 || 'The value must be greater than or equal to 0',
        v => v <= 5 || 'The value must be lower than 6'
      ],
      hsptDummy: null,
      dialog: false,
      dialogphp: false,
      showLegend: false,
      showRdoz: false,
      huis_statw_dat: "",
    }
  },
  mounted() {
    this.getAuthorization("menu-users-photographers", "editPhotographer");
    this.getAuthorization("acco-can-copy-photos", "canCopyHsft");
  },
  created() {
    bus.$on("closeDialog", (data) => {
      if (data === 'reload' || data === 'attm_m_attm') {
        this.getHuisData('closedialog');
      }
    });
    this.getHuisData('created');
  },
  computed: {
    minDate() {
      // Returns today in YYYY-MM-DD format
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    filtered_thpgp: function () {
      return this.thpgp.filter((gp) => {
        // console.log(gp, this.hpgp_periodetype)
        if (this.hpgp_periodetype === null) {
          return true;
        } else {
          if (gp.hpgp_periodtype === this.hpgp_periodetype) {
            return true;
          }
        }
        return false;
      })
    }
  },
  watch: {
    // als je gaat zoeken dan vervalt je selectie je kunt anders een niet zichtbare selectie hebben !! Gevaarlijk bij gebruik van verwijderen
    hsptDummy: {
      handler() {
        this.thpgp = this.huis.hspt[this.hsptDummy].hpgp;
      }
    },
    rental_expert: {
      handler() {
        this.huis.gebr_code_binnendienst === '' ? this.huis.gebr_code_binnendienst = this.rental_expert : false
      }
    },
    huis_statw_dat: {
      handler() {
        this.showRdoz = (this.huis.stat_code === "W" || this.huis_statw_dat > "");
      }
    }
  },
  methods: {
    updateParentNoteData(data) {
      // console.log('nott ', data)
      this.huis.nott_aant = data;
    },
    updateParentAttmData(data) {
      // console.log('m_attm ', data)
      this.huis.attm_aant = data;
    },
    getHeaders() {
      return [
        { text: "Source", sortable: false },
        { text: "Reviews", sortable: false, align: "end" },
        { text: "Average", sortable: false, align: "end" },
        { sortable: false, align: "start" }
      ];
    },
    updateAction(actie_datum_2, actie_opm) {
      this.huis.huis_actie_datum_2 = actie_datum_2;
      this.huis.huis_actie_opm = actie_opm;
      this.actionKey = this.actionKey + 1;
    },
    updateData() {
      this.getHuisData('updateData');
    },
    updateData2(data) {
      this[data.field] = data.value;
    },
    reloadHuis() {
        this.getHuisData("reloadHuis");
    },
    showDetails(entity, encrid) {
        let route = this.$router.resolve({ path: "/task/customer_success/homb/homb_overview/" + entity + ":" + encrid });
        window.open(route.href, "_blank");
    },
    getHuisData(hook) {
      console.log('getHuisData hook', hook)
      //hook==='created'?this.loading=true:this.loading=false
      this.getLegenda()
      this.$emit('readItems', 'pipo');
      this.$axios
        .post("ares/json/ares/huis/getHuis.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuis"
          },
          getHuis: {
            huis_encrid: this.huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            if (res.data.error.new_encrid !== "") {
                this.$router.reload('/huis/onHuis/' + res.data.error.new_encrid);
                return;
            }
            console.log(res.data.error);
            this.loading = false
          } else {
            this.huis = res.data.getHuis;
            this.refreshCount = this.refreshCount + 1;
            this.actionKey = this.actionKey + 1;
            try{

              document.title = 'Acco ' + res.data.getHuis.huis_code;
              this.stat_codeKeuzes = res.data.getHuis.stat_codeKeuzes;
              this.hstp_nrKeuzes = res.data.getHuis.hstp_nrKeuzes;
              this.bouw_jaarKeuzes = res.data.getHuis.bouw_jaarKeuzes;
              this.opties_dvvb_Keuzes = res.data.getHuis.opties_dvvb_Keuzes;
              this.hgrp_codeKeuzes = res.data.getHuis.hgrp_codeKeuzes;
              this.plts_nrKeuzes = res.data.getHuis.plts_nrKeuzes;
              this.prov_codeKeuzes = res.data.getHuis.prov_codeKeuzes;
              this.mrkt_nrKeuzes = res.data.getHuis.mrkt_nrKeuzes;
              this.hsav_nrKeuzes = res.data.getHuis.hsav_nrKeuzes;
              this.tijdKeuzes = res.data.getHuis.tijdKeuzes;
              this.lmterm_nrKeuzes = res.data.getHuis.lmterm_nrKeuzes;
              this.aantnacht_maxKeuzes = res.data.getHuis.aantnacht_maxKeuzes;
              this.tt_vanaf_leeftijdKeuzes = res.data.getHuis.tt_vanaf_leeftijdKeuzes;
              this.gebr_codeKeuzes = res.data.getHuis.gebr_codeKeuzes;
              this.rental_expert = res.data.getHuis.gebr_code;
              if (res.data.getHuis.hserNumberOfErrors > 0) this.hserErrorsExist = true;
              if (res.data.getHuis.hserNumberOfWarnings > 0) this.hserWarningsExist = true;
              if (res.data.getHuis.hspl.length > 1) this.moreThan1HsplRecord = true;
              this.planCode = this.huis.hspl[0].plan_code;
              this.iCal = this.huis.hspl[0].plan_ical;
              this.hspl = this.huis.hspl[0];
              this.getPlanning(this.huis.hspl[0].plan_code, new Date().getFullYear());
              // (DB) load object

// console.log("huis", res.data.getHuis);

              this.reviews = this.huis.reviews;
              if (this.reviews.reviewResetDateISO != "") {
                this.reviewResetDateDMY = this.$moment(this.reviews.reviewResetDateISO).format('DD-MM-YYYY');
              } else {
                this.reviewResetDateDMY = '';
              }
              this.contract_update_enabled = this.huis.contract_update_enabled;
              this.quality_check_data = {
                date: this.huis.quality_checked_date,
                user: this.huis.quality_checked_user,
                current_user: this.huis.quality_current_user,
                update_enabled: this.huis.quality_updatable,
                huis_encrid: this.huis.huis_encrid,
              }
              if (this.hsptDummy !== null) this.thpgp = this.huis.hspt[this.hsptDummy].hpgp;
              this.huis_statw_dat = this.huis.huis_statw_dat;

              this.rdoz_selected = [];
              this.showRdoz = (this.huis.stat_code === "W" || this.huis_statw_dat > "");
              for (let iIndex=0;iIndex<this.huis.rdoz.keuzes.length;iIndex++) {
                if (this.huis.rdoz.keuzes[iIndex].selected) {
                    this.rdoz_selected.push(this.huis.rdoz.keuzes[iIndex].value);
                }
              }
              // console.log(this.rdoz_selected);
            }catch(e){
              console.log('Error in accommodation data but we still continue. Details - ',e)
              if (typeof this.huis === 'undefined' || this.huis === null) {
                this.loading = false
                this.crash = true
              }
            }
            this.loading = false
          }
        });
    },
    saveHuisCard1() {
      if (this.$refs.huisCard1.validate()) {
        let huis_rdoz = "";
        // console.log(this.rdoz_selected)
        for (let iIndex=0;iIndex<this.rdoz_selected.length;iIndex++) {
            if (huis_rdoz>"") {
                huis_rdoz = huis_rdoz + ",";
            }
            huis_rdoz = huis_rdoz + this.rdoz_selected[iIndex];
        }
        this.$axios
          .post("ares/json/ares/huis/saveHuisCard1.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "saveHuisCard1"
            },
            saveHuisCard1: {
              huis_encrid: this.huis_encrid,
              huis_naam: this.huis.huis_naam,
              hstp_nr: parseInt(this.huis.hstp_nr),
              hgrp_code: this.huis.hgrp_code,
              plts_nr: parseInt(this.huis.plts_nr),
              prov_code: this.huis.prov_code,
              mrkt_nr: parseInt(this.huis.mrkt_nr),
              // gebr_code: this.huis.gebr_code,
              gebr_code: this.rental_expert,
              gebr_code_binnendienst: this.huis.gebr_code_binnendienst,
              stat_code: this.huis.stat_code,
              huis_statw_dat: this.huis_statw_dat,
              // huis_statw_signed_dat: this.huis.huis_statw_signed_dat,
              huis_aantpers_max: parseInt(this.huis.huis_aantpers_max),
              huis_aant_baby_os: parseInt(this.huis.huis_aant_baby_os),
              huis_ster: parseInt(this.huis.huis_ster),
              huis_adres: this.huis.huis_adres,
              huis_postcode: this.huis.huis_postcode,
              huis_combi: this.huis.huis_combi,
              huis_code_oud: this.huis.huis_code_oud,
              huis_bedr_oud: this.huis.huis_bedr_oud,
              huis_naam_org: this.huis.huis_naam_org,
              hsav_nr: parseInt(this.huis.hsav_nr),
              huis_lm_term: parseInt(this.huis.huis_lm_term),
              huis_aantnacht_max: parseInt(this.huis.huis_aantnacht_max),
              huis_tt_vanaf_leeftijd: parseInt(this.huis.huis_tt_vanaf_leeftijd),
              huis_aankomst_tijd1: this.huis.huis_aankomst_tijd1,
              huis_aankomst_tijd2: this.huis.huis_aankomst_tijd2,
              huis_vertrek_tijd1: this.huis.huis_vertrek_tijd1,
              huis_vertrek_tijd2: this.huis.huis_vertrek_tijd2,
              rdoz_code: huis_rdoz,
              rdoz_note: this.huis.rdoz.rdoz_note,
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.getHuisData('accommodation');
              this.$store.dispatch('setSnackbar', {
                showing: true,
                text: res.data.saveHuisCard1.text,
                color: res.data.saveHuisCard1.color
              });
            }
          })
      }
    },
    saveHuisCard3() {
      this.$axios
        .post("ares/json/ares/huis/saveHuisCard3.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHuisCard3"
          },
          saveHuisCard3: {
            huis_encrid: this.huis_encrid,
            huis_vimeo_url: this.huis.huis_vimeo_url,
            huis_cloudflare_video_url: this.huis.huis_cloudflare_video_url,
            huis_360_url: this.huis.huis_360_url
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.getHuisData('video');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHuisCard3.text,
              color: res.data.saveHuisCard3.color
            });
          }
        })
    },
    saveReviewResetDate() {
      // console.log("saving " + this.reviewResetDateDMY);

      this.$axios
        .post("ares/json/ares/huis/revw/updReviewResetDate.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updReviewResetDate"
          },
          updReviewResetDate: {
            huis_encrid: this.huis_encrid,
            ReviewResetDate: this.reviewResetDateDMY
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.error.message,
              color: "error"
            })
          } else {
            //console.log(res.data);
            this.getHuisData('reviewresetdate');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updReviewResetDate.text,
              color: res.data.updReviewResetDate.color
            });
          }
        })
    },
    saveHuisCard2() {
      //if(this.$refs.huisCard1.validate()) {
      this.$axios
        .post("ares/json/ares/huis/saveHuisCard2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHuisCard2"
          },
          saveHuisCard2: {
            huis_encrid: this.huis_encrid,
            huis_m2: parseInt(this.huis.huis_m2),
            huis_gebouwd_jaar: parseInt(this.huis.huis_gebouwd_jaar),
            huis_gerenoveerd_jaar: parseInt(this.huis.huis_gerenoveerd_jaar),
            huis_verhuur_start_jaar: parseInt(this.huis.huis_verhuur_start_jaar),
            huis_klnt_beoordeling: parseFloat(this.huis.huis_klnt_beoordeling),
            huis_opties_dvvb: parseInt(this.huis.huis_opties_dvvb),
            netp: this.huis.netp
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);

          } else {
            this.getHuisData('properties');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHuisCard2.text,
              color: res.data.saveHuisCard2.color
            });
          }
        })
      //}
    },
    winterfoto() {
      this.$axios
        .post("ares/json/ares/huis/updHuisWinterFoto.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHuisWinterFoto"
          },
          updHuisWinterFoto: {
            huis_encrid: this.huis_encrid,
            huis_winter_foto_volgorde: this.huis.huis_winter_foto_volgorde
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            //this.$router.reload('/huis/onHuis/' + res.data.updHuisWinterFoto.huis_encrid);
            this.getHuisData('winterfoto');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHuisWinterFoto.text,
              color: res.data.updHuisWinterFoto.color
            });
          }
        })
    },
    getHser(hser_type) {
      this.$refs.hser.open('dummy', this.huis.huis_code, hser_type);
    },
    updHsbc(hsbc_encrid) {
      this.$refs.updHsbc.open(hsbc_encrid);
    },
    updHsct(hsct_encrid) {
      this.$refs.updHsct.open(hsct_encrid);
    },
    updHsct2(hsct_encrid) {
      this.$refs.updHsct2.open(hsct_encrid);
    },
    rmHsct(hsct_encrid) {
      this.$refs.rmHsct.open(hsct_encrid);
    },
    addHsct(huis_encrid) {
      this.$refs.addHsct.open(huis_encrid);
    },
    copyHsctToHoct(huis_encrid) {
      this.$refs.copyHsctToHoct.open(huis_encrid);
    },
    clickPlan(datum, tabel, encrid) {
      if (tabel == "huov") {
        let route = this.$router.resolve({ path: '/huov/onHuov/' + encrid });
        window.open(route.href, '_blank');
      }
      if (tabel == "hpbz") {
        let route = this.$router.resolve({ path: '/hpbz/onHpbz/' + encrid + '/' + this.huis_encrid });
        window.open(route.href, '_blank');
      }
      if (tabel == "heho") {
        let route = this.$router.resolve({ path: '/heho/onHeho/' + encrid + '/' + this.huis_encrid });
        window.open(route.href, '_blank');
      }
      if (tabel == "vrij") {
        this.$refs.updPlan.open(datum, encrid);
      }
      if (tabel == "hprs") {
        this.$refs.updRmvHprs.openDialog(encrid, this.huis_encrid, true, true);
      }
      if (tabel == "geenPrijs") {
        this.$refs.updPlan.open(datum, encrid);
      }
    },
    getLegenda() {
      this.$axios
        .post("ares/json/ares/huis/hspl/getLegenda.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getLegenda"
          },
          getLegenda: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.legenda = res.data.getLegenda;
          }
        })
    },
    getPlanning(planCodePar, jaar) {
      this.$axios
        .post("ares/json/ares/huis/hspl/getPlan.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getPlan"
          },
          getPlan: {
            huis_code: this.huis.huis_code,
            plan_code: planCodePar,
            jaar: jaar
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.getPlan = res.data.getPlan;
            this.planCode = planCodePar;
            this.hspl.plan_to_code = res.data.getPlan.plan_to_code;
            this.hspl.plan_to_naam = res.data.getPlan.plan_to_naam;
            this.hspl.plan_ical = res.data.getPlan.plan_ical;
            this.hspl.huis_codes = res.data.getPlan.huis_codes;
            this.hspl.huis_is_combi = res.data.getPlan.huis_is_combi;
            this.hspl.plan_verhvergun_ref = res.data.getPlan.plan_verhvergun_ref;
            this.hspl.plan_verhvergun_stat = res.data.getPlan.plan_verhvergun_stat;
            this.hspl.plan_energie_label = res.data.getPlan.plan_energie_label;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updAddress(huis_encrid) {
      this.$refs.updAddress.open(huis_encrid);
      /*
      let route = this.$router.resolve({ path: '/huis/updAddress/' + huis_encrid});
      window.open(route.href, '_blank');
      */
    },
    updHsip(hsip_tabel, hsip_encrid, hsip_publish) {
      this.$axios
        .post("ares/json/ares/huis/updHsip.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHsip"
          },
          updHsip: {
            hsip_tabel: hsip_tabel,
            hsip_encrid: hsip_encrid,
            hsip_publish: hsip_publish
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }
        })
    },
    overruleAddress(huis_encrid) {
      this.$refs.overruleAddress.open(huis_encrid);
    },
    showMap(huis_encrid) {
      this.$refs.showMap.open(huis_encrid);
    },
    addHspl(huis_encrid) {
      this.$refs.addHspl.open(huis_encrid);
    },
    addHeho(huis_encrid) {
      this.$refs.addHeho.open(huis_encrid);
    },
    rmHspl(hspl_encrid) {
      this.$refs.rmHspl.open(hspl_encrid);
    },
    rmHspt(hspt_encrid) {
      this.$refs.rmHspt.open(hspt_encrid);
    },
    updHspl(hspl_encrid) {
      this.$refs.updHspl.open(hspl_encrid);
    },
    onHprs(hspl_encrid) {
      this.$refs.onHprs.open(hspl_encrid);
    },
    onPlsc(hspl_encrid) {
      this.$refs.onPlsc.open(hspl_encrid);
    },
    addHszn(huis_encrid) {
      this.$refs.addHszn.open(huis_encrid);
    },
    addPlts(huis_encrid) {
      this.$refs.addPlts.open(huis_encrid);
    },
    addHsaf(huis_encrid) {
      this.$refs.addHsaf.open(huis_encrid);
    },
    rmHsaf(hsaf_encrid) {
      this.$refs.rmHsaf.open(hsaf_encrid);
    },
    addHszn3(huis_encrid) {
      this.$refs.addHszn3.open(huis_encrid);
    },
    rmHszn(hszn_encrid) {
      this.$refs.rmHszn.open(hszn_encrid);
    },
    // addHsab(huis_encrid) {
    //   this.$refs.addHsab.open(huis_encrid);
    // },
    // copyHsab(huis_encrid) {
    //   this.$refs.copyHsab.open(huis_encrid);
    // },
    // rmHsab(hsab_encrid) {
    //   this.$refs.rmHsab.open(hsab_encrid);
    // },
    updTxts(huis_encrid, veld_naam, taal_code) {
      this.$refs.updTxts.open(huis_encrid, veld_naam, taal_code);
    },
    makeDate(isoDate) {
        if (!isoDate) return "";
        return isoDate.split("-").reverse().join("-");
    },
    saveHspt(hsptRecord) {
        if (hsptRecord.stat_code==='DP') {
            // Er moet een actie worden komen
            // this.actie_datum_2 = this.huis.huis_actie_datum_2;
            this.actie_datum = this.makeDate(this.huis.huis_actie_datum_2);
            this.keepHspt = hsptRecord;
            this.dp_action = true;
        } else {
            this.saveHsptStep2(hsptRecord);
        }
    },
    actionSave() {
        this.$axios.post("ares/json/ares/huis/saveHuisAction.p", {
            header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "saveHuisAction"
            },
            saveHuisAction: {
                huis_encrid: this.huis_encrid,
                actie_datum: this.huis.huis_actie_datum_2,
                actie_opm: this.huis.huis_actie_opm
            }
        }).then(res => {
            if (res.data.error) {
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: res.data.error.message,
                    color: "error"
                });
            } else {
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: res.data.saveHuisAction.text,
                    color: res.data.saveHuisAction.color
                });
                if (res.data.saveHuisAction.color === "success") {
                    this.updateAction(this.huis.huis_actie_datum_2, this.huis.huis_actie_opm);
                    this.dp_action = false;
                    this.saveHsptStep2(this.keepHspt);
                }
            }
        });
    },
    cancelHsptSave() {
        this.$store.dispatch('setSnackbar', {
            showing: true,
            text: "contract changes not saved (user cancelled)",
            color: "error"
        });
        this.dp_action = false;
    },
    saveHsptStep2(hsptRecord) {
      this.$axios
        .post("ares/json/ares/huis/hspt/saveHspt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHspt"
          },
          saveHspt: {
            hspt_encrid: hsptRecord.hspt_encrid,
            huis_encrid: hsptRecord.huis_encrid,
            cttp_nr: parseInt(hsptRecord.cttp_nr),
            hspt_rent_aant_pers: parseInt(hsptRecord.hspt_rent_aant_pers),
            hspt_flexprijs_perc: parseInt(hsptRecord.hspt_flexprijs_perc),
            hspt_rent_extra_pers_pppn_ink: parseFloat(hsptRecord.hspt_rent_extra_pers_pppn_ink),
            hspt_rent_extra_pers_pppn_verk: parseFloat(hsptRecord.hspt_rent_extra_pers_pppn_verk),
            hspt_aank_van_dat: hsptRecord.hspt_aank_van_dat,
            hspt_aank_tm_dat: hsptRecord.hspt_aank_tm_dat,
            stat_code: hsptRecord.stat_code,
            hspt_prs_strct: hsptRecord.hspt_prs_strct,
            hspt_publ_bijdrage_bedrag: parseFloat(hsptRecord.hspt_publ_bijdrage_bedrag),
            hspt_publ_bijdrage_vanaf_dat: hsptRecord.hspt_publ_bijdrage_vanaf_dat,
            // hspt_rdoz: hsptRecord.huis_rdoz_code,
            // hspt_rdoznote: hsptRecord.huis_rdoz_note,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            //this.$router.reload('/huis/onHuis/' + res.data.saveHspt.huis_encrid);
            this.getHuisData('savehspt');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHspt.text,
              color: res.data.saveHspt.color
            });
          }
        })
    },
    clearAddress(huis_encrid) {
      this.$axios
        .post("ares/json/ares/huis/clearAddress.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "clearAddress"
          },
          clearAddress: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            //this.$router.reload('/huis/onHuis/' + res.data.clearAddress.huis_encrid);
            this.getHuisData('clearaddress');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.clearAddress.text,
              color: res.data.clearAddress.color
            });
          }
        })
    },
    reloadHpbk() {
        this.getHuisData('reloadHpbk');
    },
    addHspt(huis_encrid) {
      this.$refs.addHspt.open(huis_encrid);
    },
    addHpbk(hspt_encrid) {
      this.$refs.addHpbk.openDialog(hspt_encrid, "");
    },
    viewHpbkDetails(kstp, hspt_encrid, regels) {
        this.$refs.viewHpbkDetails.openDetailView(kstp, hspt_encrid, regels);
    },
    addHpgp(hspt_encrid) {
      this.$refs.addHpgp.open(hspt_encrid);
    },
    addHpbr(hspt_encrid) {
      this.$refs.addHpbr.open(hspt_encrid);
    },
    rmHpbk(hpbk_encrid) {
      this.$refs.rmHpbk.open(hpbk_encrid);
    },
    rmHpbr(hpbr_encrid) {
      this.$refs.rmHpbr.open(hpbr_encrid);
    },
    rmHpgp(hpgp_encrid) {
      this.$refs.rmHpgp.open(hpgp_encrid);
    },
    updHsnp(hspt_encrid) {
      let route = this.$router.resolve({ path: '/huis/hspt/hsnp/updHsnp/' + hspt_encrid });
      window.open(route.href, '_blank');
    },
    updHsfp(hspt_encrid) {
      let route = this.$router.resolve({ path: '/huis/hspt/hsfp/updHsfp/' + hspt_encrid });
      window.open(route.href, '_blank');
    },
    showHosm(huis_encrid) {
      let route = this.$router.resolve({ path: '/task/customer_success/hosm/hosm_overview/huis:' + huis_encrid }); //props: ['huis_encrid'],
      window.open(route.href, '_blank');
    },
    showRevw(huis_encrid) {
      let route = this.$router.resolve({ path: '/task/customer_success/revw/revw_overview3/huis:' + huis_encrid }); //props: ['huis_encrid'],
      window.open(route.href, '_blank');
    },
    addHsft2(huis_encrid) {
      this.$refs.addHsft2.open(huis_encrid);
    },
    bulkDelHsft(huis) {
      this.$refs.bulkDelHsft.openDialog(huis);
    },
    viewAllHsft(huis_encrid) {
      this.$refs.viewAllHsft.open(huis_encrid);
    },
    orderHsft(huis_encrid, summer_winter) {
      this.$refs.orderHsft.open(huis_encrid, summer_winter);
    },
    viewDelHsft(huis_encrid) {
      this.$refs.viewDelHsft.open(huis_encrid);
    },
    viewProcessingHsft(huis_encrid) {
      this.$refs.viewProcessingHsft.open(huis_encrid);
    },
    downloadAllHsftZip(huis_encrid) {
      this.$refs.downloadAllHsftZip.open(huis_encrid);
    },
    viewPhotoAssignments(huis_encrid) {
      this.$refs.viewPhotoAssignments.open(huis_encrid);
    },
    copyHsft(huis) {
      this.$refs.copyHsft.open(huis);
    },
    updHsft(hsft_encrid) {
      this.$refs.updHsft.open(hsft_encrid);
    },
    // m_attm(huis_encrid){
    //     this.$refs.m_attm.open('huis', this.huis.huis_code, '', 'huis', huis_encrid, 0);
    // },
    // nott(huis_encrid) {
    //   this.$refs.nott.open("huis",huis_encrid,"all");
    // },
    copyToClipboard(text) {
      // navigator will not work in DEV which is HTTP
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        this.unsecuredCopyToClipboard(text);
      }
    },
    unsecuredCopyToClipboard(text) {

      // create dummy text area
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      // add dummy element and select it
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy'); // deprecated but it still works, for DEV this is acceptable
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      // kill dummy element
      document.body.removeChild(textArea);
    },
    loadVfyPage(url) {
      window.open(url);
    },
    getAuth(login_user) {
      return localStorage.getItem('login') === login_user
    },
    getCurrentUser() {
      return localStorage.getItem('login')
    },
    actionClick(action) {
      switch (action) {
        case "nott": this.$refs.nott.open("huis", this.huis_encrid, "all"); break;
        case "m_attm": this.$refs.m_attm.open('huis', this.huis.huis_code, '', 'huis', this.huis_encrid, 0); break;
        case "updatewebsites": this.$refs.updateWebsites.open(this.huis_encrid); break;
        case "websitePrice": this.$refs.websitePrice.open(this.huis_encrid); break;
        case "showICal": this.$refs.showICal.open(this.huis_encrid); break;
        case "rmHuis": this.$refs.rmHuis.open(this.huis_encrid); break;
        case "excelOmzet1": this.$refs.excelOmzet1.open(this.huis_encrid); break;
        case "updFrtt": this.$refs.updFrtt.open(this.huis_encrid); break;
        // case "vfyWebsiteNL" :  window.open('https://www.villaforyou.com/rdr/internal/bk/' + this.huis.gebr_encrid + '/nl/' + this.huis.huis_code); break;
        // case "vfyWebsiteDE" :  window.open('https://www.villaforyou.com/rdr/internal/bk/' + this.huis.gebr_encrid + '/de/' + this.huis.huis_code); break;
        // case "vfyWebsiteEN" :  window.open('https://www.villaforyou.com/rdr/internal/bk/' + this.huis.gebr_encrid + '/en/' + this.huis.huis_code); break;
        // case "vfyWebsiteFR" :  window.open('https://www.villaforyou.com/rdr/internal/bk/' + this.huis.gebr_encrid + '/fr/' + this.huis.huis_code); break;
        case "vfyMarkWebsiteNL": window.open('https://localhost:3000/nl/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "vfyMarkWebsiteDE": window.open('https://localhost:3000/de/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        // case "vfyChanSanWebsiteNL" :  window.open('https://www.villaforyou.com/nl/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        // case "vfyChanSanWebsiteDE" :  window.open('https://www.villaforyou.com/de/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        // case "vfyChanSanWebsiteEN" :  window.open('https://www.villaforyou.com/en/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        // case "vfyChanSanWebsiteFR" :  window.open('https://www.villaforyou.com/fr/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "vfyWebsiteNL": window.open('https://www.villaforyou.com/nl/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "vfyWebsiteDE": window.open('https://www.villaforyou.com/de/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "vfyWebsiteEN": window.open('https://www.villaforyou.com/en/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "vfyWebsiteTEST": window.open('https://test.villaforyou.com/nl/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "vfyWebsiteFR": window.open('https://www.villaforyou.com/fr/acco/' + this.huis.huis_code + '?csEncId=' + this.huis.gebrcode_encrid + '&csUser=' + this.huis.gebr_name); break;
        case "showHsva": {
          let route = this.$router.resolve({ path: '/huis/hsva/showHsva/' + this.huis.huis_encrid });
          window.open(route.href, '_blank');
          break;
        }
      }
    },
    onStatChange(event) {
        // console.log(event)
        this.showRdoz = (event === "W");
    }
  }
};

</script>

<style src="@/assets/plan.css"></style>
<style>
.br_small {
  display: block;
  margin-bottom: 0em;
}

.br_medium {
  display: block;
  margin-bottom: 1em;
}

.br_large {
  display: block;
  margin-bottom: 2em;
}

.vet {
  font-weight: bold;
  font-size: 200;
}

.normaal {
  font-weight: 200;
  font-size: small;
}

.zwart {
  color: black;
}

.wit {
  color: white;
  font-weight: bold;
}

.huisHspl tr:hover {
  background-color: #1976D2;
  /* primary coplor */
  color: white;
}

.welTekst {
  color: #4CAF50;
  /* success */
  text-align: center;
}

.geenTekstError {
  color: #FF5252;
  /* error */
  text-align: center;
}

.geenTekst {
  color: #000000;
  /*  */
  text-align: center;
}

#content figcaption {
  font-size: 11px;
  text-shadow: none;
  color: black;
  height: auto;
  word-wrap: break-word;
  width: 120px;
}

.ptr {
  cursor: pointer;
}

.text-field-style>>>.v-text-field__slot input {
  color: grey;
  font-weight: 300;
  /* 800 being bold so this is less than half bold */
}

.text-grey {
  color: grey !important;
  font-weight: 400 !important;
  /* 800 being bold so this is half bold */
}

.hsipline_markup {
  margin-top: 8px;
  font-size: 11pt !important;
}

.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.last-item {
  margin-left: auto;
}

.column {
  position: inherit;
  width: 20%;
}

.col-value {
  float: right;
  font-weight: bold;
  padding-right: 40px;
}

.noborder {
  border: 0px !important;
  /* height: 12px !important; */
}

.onlyborder {
  height: 2px !important;
}

.detail {
  height: 12px !important;
}

.thgp-select {
  margin-left: 18px;
  width: 300px !important;
}

.table-header {
  font-weight: 700;
}

.errorfab {
  position: fixed;
  left: 0.75rem; /* 3 * 0.25rem */
  top: 5.75rem; /* 3 * 0.25rem */
  border: 5px solid white;
  border-radius: 50%; /* rounded-full */
  font-weight: bold;
  font-size: 3rem; /* text-2xl */
  background-color: red;
  color: white;
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Ensure it is always on top */
  cursor: pointer; /* Change cursor to pointer */
}

.cell {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.cell:hover {
  background-color: #1976D2;
  color: white;
  cursor: pointer;
}
.xheader {
  display: flex;
  flex-direction: row;
  justify-items: left;
  align-items: center;
  padding-right: 5px;
  padding-left: 5px;
}
.error-indent {
  padding-left: 90px;
}
.ai_adjusted {
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  margin-left: 0.3rem;
  -webkit-filter: drop-shadow( 2px 2px 1px rgba(0, 0, 0, 0.9));
  filter: drop-shadow( 2px 2px 1px rgba(0, 0, 0, .9));
}
</style>
